import React from 'react';
import { NavLink } from 'react-router-dom';

const StepThanks = ({ transactionDetails }) => {
   // Formatear la fecha y hora
   const formatDateTime = (dateString) => {
      if (!dateString) return 'N/A';

      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid date';

      // Formatear la fecha como DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      // Formatear la hora como HH:MM AM/PM
      let hours = date.getHours();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // La hora '0' debe ser '12'
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${day}/${month}/${year} at ${hours}:${minutes} ${ampm}`;
   };

   // Obtener el número de orden de forma segura
   const getOrderNumber = () => {
      if (!transactionDetails) return 'PLW321';

      // Usar _id como primera opción para el número de orden
      if (transactionDetails._id) {
         return transactionDetails._id;
      }

      // Si no hay _id, intentar usar uuid o codeTX
      if (transactionDetails.uuid) {
         return transactionDetails.uuid;
      }

      if (transactionDetails.codeTX) {
         return transactionDetails.codeTX;
      }

      // Valor por defecto si no se encuentra ningún identificador
      return 'PLW321';
   };

   return (
      <div className="modal_content_body text-center">
         <h3 className="ppt_form_title mb-3 text-center">Wire, ACH & Swift Bank Transfer</h3>
         <div className='ppt_deposit_item'>
            <img
               src={process.env.PUBLIC_URL + '/assets/img/icon_check.svg'}
               alt=""
               style={{ width: '100px' }}
               className="d-block mb-2 mx-auto"
            />
            <p className="col-lg-10 mx-lg-auto mb-2">
               <strong className='d-block mb-2'>Order confirmed!</strong>
               Thank you for your deposit request. Your transaction has been logged in our system and will be processed once the funds are received. Please allow up to 10 business days for the funds to reflect in your account.
            </p>
            <div className='ppt_deposit_item gap-1 py-3' style={{ backgroundColor: '#E0E0E0' }}>
               <strong className='d-block'>Order details</strong>
               <small>
                  <strong>Order number:</strong> {getOrderNumber()}<br />
                  {/* <strong>Payment amount:</strong> ${transactionDetails?.amount || '0.00'}<br /> */}
                  {/* <strong>Token amount ordered:</strong> {transactionDetails?.amount ? (transactionDetails.amount / 0.22).toFixed(2) : '0.00'} PROPT<br /> */}
                  <strong>Date & Time of order:</strong> {formatDateTime(transactionDetails?.createdAt)}
               </small>
            </div>
            <div className="d-flex justify-content-center gap-3 pt-2">
               <small><strong>For any inquiry on your order's status please contact sales at <NavLink className='t-anchor' to='tel:+18242585211'><u>+1 824 258 5211</u></NavLink> or use the <NavLink className='t-anchor' to=''><u>chat bot</u></NavLink>.</strong></small>
            </div>
         </div>
      </div>
   );
};

export default StepThanks;